import React from "react";
import Footer from './components/Footer.js';
import { HelmetProvider } from "react-helmet-async";

function Pricacypolicy() {

    return (
        <div>
            <HelmetProvider>
                <title>Privacy Policy | Quran Point by SkyRaan Technologies</title>
                <meta name="description" content="Read our privacy policy to understand how Quran Point by SkyRaan Technologies collects, uses, and protects your data." />
                <meta name="keywords" content="Quran app privacy policy, data protection, Islamic app policy, user privacy, SkyRaan Technologies" />


            </HelmetProvider>
            
            <div className="my-10   lg:my-16 px-10 lg:px-24 ">
                <p>
                    <strong>PRIVACY POLICY</strong>
                </p>
                <p>
                    <strong>Last updated March 03, 2025</strong>
                </p>
                <p>
                    This Privacy Notice for Skyraan Technologies OPC Private Limited ("<strong>we</strong>,"
                    "<strong>us</strong>," or "<strong>our</strong>"), describes how and why we
                    might access, collect, store, use, and/or share ("<strong>process</strong>")
                    your personal information when you use our services ("<strong>Services</strong>"),
                    including when you:
                </p>
                <ul>
                    <li>
                        Download and use our mobile application (Quran Point), or any other
                        application of ours that links to this Privacy Notice
                    </li>
                    <li>
                        Use Quran Point. A mobile app for referring the divine book of Islam.
                    </li>
                    <li>
                        Engage with us in other related ways, including any sales, marketing,
                        or events
                    </li>
                </ul>
                <p>
                    <strong>Questions or concerns?</strong>Reading this Privacy Notice will help
                    you understand your privacy rights and choices. We are responsible for
                    making decisions about how your personal information is processed. If you do
                    not agree with our policies and practices, please do not use our Services.
                    If you still have any questions or concerns, please contact us at
                     &nbsp;
                     <a className="text-blue-500" href="mailto:support@quranpoint.com" >support@quranpoint.com.</a>
                </p>
                <p>
                    <strong>SUMMARY OF KEY POINTS</strong>
                </p>
                <p>
                    <strong>
                        <em>This summary provides key points from our Privacy Notice, but you
                            can find out more details about any of these topics by clicking the link
                            following each key point or by using our</em>
                    </strong>
                    <strong><em>table of contents</em></strong>
                    <strong>
                        <em>below to find the section you are looking for.</em>
                    </strong>
                </p>
                <p>
                    <strong>What personal information do we process?</strong> When you visit,
                    use, or navigate our Services, we may process personal information depending
                    on how you interact with us and the Services, the choices you make, and the
                    products and features you use. Learn more about personal information you
                    disclose to us.
                </p>
                <p>
                    <strong>Do we process any sensitive personal information?</strong>Some of
                    the information may be considered "special" or "sensitive" in certain
                    jurisdictions, for example your racial or ethnic origins, sexual
                    orientation, and religious beliefs. We do not process sensitive personal
                    information.
                </p>
                <p>
                    <strong>Do we collect any information from third parties?</strong> We do not
                    collect any information from third parties.
                </p>
                <p>
                    <strong>How do we process your information?</strong> We process your
                    information to provide, improve, and administer our Services, communicate
                    with you, for security and fraud prevention, and to comply with law. We may
                    also process your information for other purposes with your consent. We
                    process your information only when we have a valid legal reason to do so.
                    Learn more about how we process your information.
                </p>
                <p>
                    <strong>
                        In what situations and with which parties do we share personal
                        information?
                    </strong>
                    We may share information in specific situations and with specific third
                    parties. Learn more about when and with whom we share your personal
                    information.
                </p>
                <p>
                    <strong>How do we keep your information safe?</strong> We have adequate
                    organizational and technical processes and procedures in place to protect
                    your personal information. However, no electronic transmission over the
                    internet or information storage technology can be guaranteed to be 100%
                    secure, so we cannot promise or guarantee that hackers, cybercriminals, or
                    other unauthorized third parties will not be able to defeat our security and
                    improperly collect, access, steal, or modify your information. Learn more
                    about how we keep your information safe.
                </p>
                <p>
                    <strong>What are your rights?</strong> Depending on where you are located
                    geographically, the applicable privacy law may mean you have certain rights
                    regarding your personal information. Learn more about your privacy rights.
                </p>
                <p>
                    <strong>How do you exercise your rights?</strong> The easiest way to
                    exercise your rights is by submitting a data subject access request, or by
                    contacting us. We will consider and act upon any request in accordance with
                    applicable data protection laws.
                </p>
                <p>
                    Want to learn more about what we do with any information we collect? Review
                    the Privacy Notice in full.
                </p>
                <p>
                    <strong>1. WHAT INFORMATION DO WE COLLECT?</strong>
                </p>
                <p>
                    <strong>Personal information you disclose to us</strong>
                </p>
                <p>
                    <strong><em>In Short:</em></strong>
                    <em>
                        We collect personal information that you provide to us.
                    </em>
                </p>
                <p>
                    We collect personal information that you voluntarily provide to us when you
                    register on the Services, express an interest in obtaining information about
                    us or our products and Services, when you participate in activities on the
                    Services, or otherwise when you contact us.
                </p>
                <p>
                    <strong>Personal Information Provided by You.</strong> The personal
                    information that we collect depends on the context of your interactions with
                    us and the Services, the choices you make, and the products and features you
                    use. The personal information we collect may include the following:
                </p>
                <p>
                    <strong><u>Data We Collect</u></strong>
                </p>
                <p>
                    When you log in to the app using Google, Facebook, or Apple, we may collect
                    the following information:
                </p>
                <p>
                    <strong><u>Google Login:</u></strong>
                </p>
                <ul>
                    <li>
                        Email address
                    </li>
                    <li>
                        Full name
                    </li>
                    <li>
                        Profile picture
                    </li>
                </ul>
                <p>
                    <strong><u>Facebook Login:</u></strong>
                </p>
                <ul>
                    <li>
                        Email address
                    </li>
                    <li>
                        Full name
                    </li>
                    <li>
                        Profile picture
                    </li>
                    <li>
                        Optional information like gender and friends list <br />
                    </li>
                </ul>
                <p>
                    <strong><u>Apple Login:</u></strong>
                </p>
                <ul>
                    <li>
                        Email address (real or masked)
                    </li>
                    <li>
                        Full name
                    </li>
                    <li>
                        Apple ID identifier
                    </li>
                </ul>
                <p>
                    How We Use Your Data
                </p>
                <p>
                    We use your data to:
                </p>
                <ul>
                    <li>
                        Create and manage your account
                    </li>
                    <li>
                        Personalize your app experience
                    </li>
                    <li>
                        Send notifications, updates, and other communications
                    </li>
                    <li>
                        Improve our services and app features
                    </li>
                </ul>
                <p>
                    <strong>Data Security</strong>
                </p>
                <p>
                    We take your privacy seriously and use industry-standard encryption and
                    security measures to protect your data.
                </p>
                <p>
                    <strong>Sensitive Information.</strong> We do not process sensitive
                    information.
                </p>
                <p>
                    <strong>Social Media Login Data.</strong>We may provide you with the option
                    to register with us using your existing social media account details, like
                    your Facebook, Google, Apple account. If you choose to register in this way,
                    we will collect certain profile information about you from the social media
                    provider, as described in the section called "HOW DO WE HANDLE YOUR SOCIAL
                    LOGINS?" below.
                </p>
                <p>
                    <strong>Application Data.</strong> If you use our application(s), we also
                    may collect the following information if you choose to provide us with
                    access or permission:
                </p>
                <ul>
                    <li>
                        <em>Mobile Device Access.</em> We may request access or permission to
                        certain features from your mobile device, including your mobile device's
                        calendar, storage, social media accounts, and other features. If you
                        wish to change our access or permissions, you may do so in your device's
                        settings.
                    </li>
                    <li>
                        <em>Mobile Device Data.</em> We automatically collect device
                        information (such as your mobile device ID, model, and manufacturer),
                        operating system, version information and system configuration
                        information, device and application identification numbers, browser type
                        and version, hardware model Internet service provider and/or mobile
                        carrier, and Internet Protocol (IP) address (or proxy server). If you
                        are using our application(s), we may also collect information about the
                        phone network associated with your mobile device, your mobile device's
                        operating system or platform, the type of mobile device you use, your
                        mobile device's unique device ID, and information about the features of
                        our application(s) you accessed.
                    </li>
                    <li>
                        <em>Push Notifications.</em> We may request to send you push
                        notifications regarding your account or certain features of the
                        application(s). If you wish to opt out from receiving these types of
                        communications, you may turn them off in your device's settings.
                    </li>
                </ul>
                <p>
                    This information is primarily needed to maintain the security and operation
                    of our application(s), for troubleshooting, and for our internal analytics
                    and reporting purposes.
                </p>
                <p>
                    All personal information that you provide to us must be true, complete, and
                    accurate, and you must notify us of any changes to such personal
                    information.
                </p>
                <p>
                    <strong>Information automatically collected</strong>
                </p>
                <p>
                    <strong><em>In Short:</em></strong>
                    <em>
                        Some information - such as your Internet Protocol (IP) address and/or
                        browser and device characteristics - is collected automatically when you
                        visit our Services.
                    </em>
                </p>
                <p>
                    We automatically collect certain information when you visit, use, or
                    navigate the Services. This information does not reveal your specific
                    identity (like your name or contact information) but may include device and
                    usage information, such as your IP address, browser and device
                    characteristics, operating system, language preferences, referring URLs,
                    device name, country, location, information about how and when you use our
                    Services, and other technical information. This information is primarily
                    needed to maintain the security and operation of our Services, and for our
                    internal analytics and reporting purposes.
                </p>
                <p>
                    Like many businesses, we also collect information through cookies and
                    similar technologies.
                </p>
                <p>
                    The information we collect includes:
                </p>
                <ul>
                    <li>
                        <em>Log and Usage Data.</em> Log and usage data is service-related,
                        diagnostic, usage, and performance information our servers automatically
                        collect when you access or use our Services and which we record in log
                        files. Depending on how you interact with us, this log data may include
                        your IP address, device information, browser type, and settings and
                        information about your activity in the Services (such as the date/time
                        stamps associated with your usage, pages and files viewed, searches, and
                        other actions you take such as which features you use), device event
                        information (such as system activity, error reports (sometimes called
                        "crash dumps"), and hardware settings).
                    </li>
                    <li>
                        <em>Device Data.</em> We collect device data such as information about
                        your computer, phone, tablet, or other device you use to access the
                        Services. Depending on the device used, this device data may include
                        information such as your IP address (or proxy server), device and
                        application identification numbers, location, browser type, hardware
                        model, Internet service provider and/or mobile carrier, operating
                        system, and system configuration information.
                    </li>
                </ul>
                <p>
                    <strong>2. HOW DO WE PROCESS YOUR INFORMATION?</strong>
                </p>
                <p>
                    <strong><em>In Short:</em></strong>
                    <em>
                        We process your information to provide, improve, and administer our
                        Services, communicate with you, for security and fraud prevention, and
                        to comply with law. We may also process your information for other
                        purposes with your consent.
                    </em>
                </p>
                <p>
                    <strong>
                        We process your personal information for a variety of reasons, depending
                        on how you interact with our Services, including:
                    </strong>
                </p>
                <ul>
                    <li>

                        <strong>
                            To facilitate account creation and authentication and otherwise
                            manage user accounts.
                        </strong>
                        We may process your information so you can create and log in to your
                        account, as well as keep your account in working order.
                    </li>
                    <li>
                        <strong>To request feedback.</strong>We may process your information
                        when necessary to request feedback and to contact you about your use of
                        our Services.
                    </li>
                    <li>
                        <strong>To save or protect an individual's vital interest.</strong> We
                        may process your information when necessary to save or protect an
                        individual's vital interest, such as to prevent harm.
                    </li>
                </ul>
                <p>
                    <strong>
                        3. WHAT LEGAL BASES DO WE RELY ON TO PROCESS YOUR INFORMATION?
                    </strong>
                </p>
                <p>
                    <strong><em>In Short:</em></strong>
                    <em>
                        We only process your personal information when we believe it is
                        necessary and we have a valid legal reason (i.e., legal basis) to do so
                        under applicable law, like with your consent, to comply with laws, to
                        provide you with services to enter into or fulfill our contractual
                        obligations, to protect your rights, or to fulfill our legitimate
                        business interests.
                    </em>
                </p>
                <p>
                    <strong>
                        <em><u>If you are located in the EU or UK, this section applies to you.</u></em>
                    </strong>
                </p>
                <p>
                    The General Data Protection Regulation (GDPR) and UK GDPR require us to
                    explain the valid legal bases we rely on in order to process your personal
                    information. As such, we may rely on the following legal bases to process
                    your personal information:
                </p>
                <ul>
                    <li>
                        <strong>Consent.</strong>We may process your information if you have
                        given us permission (i.e., consent) to use your personal information for
                        a specific purpose. You can withdraw your consent at any time. Learn
                        more about withdrawing your consent.
                    </li>
                    <li>
                        <strong>Legitimate Interests.</strong> We may process your information
                        when we believe it is reasonably necessary to achieve our legitimate
                        business interests and those interests do not outweigh your interests
                        and fundamental rights and freedoms. For example, we may process your
                        personal information for some of the purposes described in order to:
                        <ul>
                            <li>
                                Understand how our users use our products and services so we
                                can improve user experience
                            </li>
                        </ul>
                    </li>
                    <li>
                        <strong>Legal Obligations.</strong> We may process your information
                        where we believe it is necessary for compliance with our legal
                        obligations, such as to cooperate with a law enforcement body or
                        regulatory agency, exercise or defend our legal rights, or disclose your
                        information as evidence in litigation in which we are involved. <br />
                    </li>
                    <li>
                        <strong>Vital Interests.</strong> We may process your information
                        where we believe it is necessary to protect your vital interests or the
                        vital interests of a third party, such as situations involving potential
                        threats to the safety of any person.
                    </li>
                </ul>
                <p>
                    <strong>
                        <em><u>If you are located in Canada, this section applies to you.</u></em>
                    </strong>
                </p>
                <p>
                    We may process your information if you have given us specific permission
                    (i.e., express consent) to use your personal information for a specific
                    purpose, or in situations where your permission can be inferred (i.e.,
                    implied consent). You can withdraw your consent at any time.
                </p>
                <p>
                    In some exceptional cases, we may be legally permitted under applicable law
                    to process your information without your consent, including, for example:
                </p>
                <ul>
                    <li>
                        If collection is clearly in the interests of an individual and consent
                        cannot be obtained in a timely way
                    </li>
                    <li>
                        For investigations and fraud detection and prevention
                    </li>
                    <li>
                        For business transactions provided certain conditions are met
                    </li>
                    <li>
                        If it is contained in a witness statement and the collection is
                        necessary to assess, process, or settle an insurance claim
                    </li>
                    <li>
                        For identifying injured, ill, or deceased persons and communicating
                        with next of kin
                    </li>
                    <li>
                        If we have reasonable grounds to believe an individual has been, is,
                        or may be victim of financial abuse
                    </li>
                    <li>
                        If it is reasonable to expect collection and use with consent would
                        compromise the availability or the accuracy of the information and the
                        collection is reasonable for purposes related to investigating a breach
                        of an agreement or a contravention of the laws of Canada or a province
                    </li>
                    <li>
                        If disclosure is required to comply with a subpoena, warrant, court
                        order, or rules of the court relating to the production of records
                    </li>
                    <li>
                        If it was produced by an individual in the course of their employment,
                        business, or profession and the collection is consistent with the
                        purposes for which the information was produced
                    </li>
                    <li>
                        If the collection is solely for journalistic, artistic, or literary
                        purposes
                    </li>
                    <li>
                        If the information is publicly available and is specified by the
                        regulations
                    </li>
                </ul>
                <p>
                    <strong>
                        4. WHEN AND WITH WHOM DO WE SHARE YOUR PERSONAL INFORMATION?
                    </strong>
                </p>
                <p>
                    <strong><em>In Short:</em></strong>
                    <em>
                        We may share information in specific situations described in this
                        section and/or with the following third parties.
                    </em>
                </p>
                <p>
                    We may need to share your personal information in the following situations:
                </p>
                <ul>
                    <li>
                        <strong>Business Transfers.</strong> We may share or transfer your
                        information in connection with, or during negotiations of, any merger,
                        sale of company assets, financing, or acquisition of all or a portion of
                        our business to another company.
                    </li>
                </ul>
                <p>
                    <strong>5. WHAT IS OUR STANCE ON THIRD-PARTY WEBSITES?</strong>
                </p>
                <p>
                    <strong><em>In Short:</em></strong>
                    <em>
                        We are not responsible for the safety of any information that you share
                        with third parties that we may link to or who advertise on our Services,
                        but are not affiliated with, our Services.
                    </em>
                </p>
                <p>
                    The Services may link to third-party websites, online services, or mobile
                    applications and/or contain advertisements from third parties that are not
                    affiliated with us and which may link to other websites, services, or
                    applications. Accordingly, we do not make any guarantee regarding any such
                    third parties, and we will not be liable for any loss or damage caused by
                    the use of such third-party websites, services, or applications. The
                    inclusion of a link towards a third-party website, service, or application
                    does not imply an endorsement by us. We cannot guarantee the safety and
                    privacy of data you provide to any third-party websites. Any data collected
                    by third parties is not covered by this Privacy Notice. We are not
                    responsible for the content or privacy and security practices and policies
                    of any third parties, including other websites, services, or applications
                    that may be linked to or from the Services. You should review the policies
                    of such third parties and contact them directly to respond to your
                    questions.
                </p>
                <p>
                    <strong>6. DO WE USE COOKIES AND OTHER TRACKING TECHNOLOGIES?</strong>
                </p>
                <p>
                    <strong><em>In Short:</em></strong>
                    <em>
                        We may use cookies and other tracking technologies to collect and store
                        your information.
                    </em>
                </p>
                <p>
                    We may use cookies and similar tracking technologies (like web beacons and
                    pixels) to gather information when you interact with our Services. Some
                    online tracking technologies help us maintain the security of our Services
                    and your account, prevent crashes, fix bugs, save your preferences, and
                    assist with basic site functions.
                </p>
                <p>
                    We also permit third parties and service providers to use online tracking
                    technologies on our Services for analytics and advertising, including to
                    help manage and display advertisements, to tailor advertisements to your
                    interests, or to send abandoned shopping cart reminders (depending on your
                    communication preferences). The third parties and service providers use
                    their technology to provide advertising about products and services tailored
                    to your interests which may appear either on our Services or on other
                    websites.
                </p>
                <p>
                    To the extent these online tracking technologies are deemed to be a
                    "sale"/"sharing" (which includes targeted advertising, as defined under the
                    applicable laws) under applicable US state laws, you can opt out of these
                    online tracking technologies by submitting a request as described below
                    under section "DO UNITED STATES RESIDENTS HAVE SPECIFIC PRIVACY RIGHTS?"
                </p>
                <p>
                    Specific information about how we use such technologies and how you can
                    refuse certain cookies is set out in our Cookie Notice.
                </p>
                <p>
                    <strong></strong>
                </p>
                <p>
                    <strong>Google Analytics</strong>
                </p>
                <p>
                    We may share your information with Google Analytics to track and analyze the
                    use of the Services. The Google Analytics Advertising Features that we may
                    use include: Google Display Network Impressions Reporting, Google Analytics
                    Demographics and Interests Reporting and Remarketing with Google Analytics.
                    To opt out of being tracked by Google Analytics across the Services, visit
                    <a href="https://tools.google.com/dlpage/gaoptout">
                        <u>https://tools.google.com/dlpage/gaoptout</u>
                    </a>
                    . You can opt out of Google Analytics Advertising Features through
                    <a href="https://adssettings.google.com/">
                        <u>Ads Settings</u>
                    </a>
                    and Ad Settings for mobile apps. Other opt out means include
                    <a href="http://optout.networkadvertising.org/">
                        <u>http://optout.networkadvertising.org/</u>
                    </a>
                    and
                    <a href="http://www.networkadvertising.org/mobile-choice">
                        <u>http://www.networkadvertising.org/mobile-choice</u>
                    </a>
                    . For more information on the privacy practices of Google, please visit the
                    <a href="https://policies.google.com/privacy">
                        <u>Google Privacy &amp; Terms page</u>
                    </a>
                    .
                </p>
                <p>
                    <strong>7. HOW DO WE HANDLE YOUR SOCIAL LOGINS?</strong>
                </p>
                <p>
                    <strong><em>In Short:</em></strong>
                    <em>
                        If you choose to register or log in to our Services using a social media
                        account, we may have access to certain information about you.
                    </em>
                </p>
                <p>
                    Our Services offer you the ability to register and log in using your
                    third-party social media account details (like your Facebook or X logins).
                    Where you choose to do this, we will receive certain profile information
                    about you from your social media provider. The profile information we
                    receive may vary depending on the social media provider concerned, but will
                    often include your name, email address, friends list, and profile picture,
                    as well as other information you choose to make public on such a social
                    media platform.
                </p>
                <p>
                    We will use the information we receive only for the purposes that are
                    described in this Privacy Notice or that are otherwise made clear to you on
                    the relevant Services. Please note that we do not control, and are not
                    responsible for, other uses of your personal information by your third-party
                    social media provider. We recommend that you review their privacy notice to
                    understand how they collect, use, and share your personal information, and
                    how you can set your privacy preferences on their sites and apps.
                </p>
                <p>
                    <strong>8. HOW LONG DO WE KEEP YOUR INFORMATION?</strong>
                </p>
                <p>
                    <strong><em>In Short:</em></strong>
                    <em>
                        We keep your information for as long as necessary to fulfill the
                        purposes outlined in this Privacy Notice unless otherwise required by
                        law.
                    </em>
                </p>
                <p>
                    We will only keep your personal information for as long as it is necessary
                    for the purposes set out in this Privacy Notice, unless a longer retention
                    period is required or permitted by law (such as tax, accounting, or other
                    legal requirements). No purpose in this notice will require us keeping your
                    personal information for longer than the period of time in which users have
                    an account with us.
                </p>
                <p>
                    When we have no ongoing legitimate business need to process your personal
                    information, we will either delete or anonymize such information, or, if
                    this is not possible (for example, because your personal information has
                    been stored in backup archives), then we will securely store your personal
                    information and isolate it from any further processing until deletion is
                    possible.
                </p>
                <p>
                    <strong>9. HOW DO WE KEEP YOUR INFORMATION SAFE?</strong>
                </p>
                <p>
                    <strong><em>In Short:</em></strong>
                    <em>
                        We aim to protect your personal information through a system of
                        organizational and technical security measures.
                    </em>
                </p>
                <p>
                    We have implemented appropriate and reasonable technical and organizational
                    security measures designed to protect the security of any personal
                    information we process. However, despite our safeguards and efforts to
                    secure your information, no electronic transmission over the Internet or
                    information storage technology can be guaranteed to be 100% secure, so we
                    cannot promise or guarantee that hackers, cybercriminals, or other
                    unauthorized third parties will not be able to defeat our security and
                    improperly collect, access, steal, or modify your information. Although we
                    will do our best to protect your personal information, transmission of
                    personal information to and from our Services is at your own risk. You
                    should only access the Services within a secure environment.
                </p>
                <p>
                    <strong>10. WHAT ARE YOUR PRIVACY RIGHTS?</strong>
                </p>
                <p>
                    <strong><em>In Short:</em></strong>
                    <em>
                        Depending on your state of residence in the US or in some regions, such
                        as the European Economic Area (EEA), United Kingdom (UK), Switzerland,
                        and Canada, you have rights that allow you greater access to and control
                        over your personal information. You may review, change, or terminate
                        your account at any time, depending on your country, province, or state
                        of residence.
                    </em>
                </p>
                <p>
                    In some regions (like the EEA, UK, Switzerland, and Canada), you have
                    certain rights under applicable data protection laws. These may include the
                    right (i) to request access and obtain a copy of your personal information,
                    (ii) to request rectification or erasure; (iii) to restrict the processing
                    of your personal information; (iv) if applicable, to data portability; and
                    (v) not to be subject to automated decision-making. In certain
                    circumstances, you may also have the right to object to the processing of
                    your personal information. You can make such a request by contacting us by
                    using the contact details provided in the section "HOW CAN YOU CONTACT US
                    ABOUT THIS NOTICE?" below.
                </p>
                <p>
                    We will consider and act upon any request in accordance with applicable data
                    protection laws.
                </p>
                <p>
                    If you are located in the EEA or UK and you believe we are unlawfully
                    processing your personal information, you also have the right to complain to
                    your
                    <a
                        href="https://ec.europa.eu/justice/data-protection/bodies/authorities/index_en.htm"
                    >
                        <u>Member State data protection authority</u>
                    </a>
                    or
                    <a
                        href="https://ico.org.uk/make-a-complaint/data-protection-complaints/data-protection-complaints/"
                    >
                        <u>UK data protection authority</u>
                    </a>
                    .
                </p>
                <p>
                    If you are located in Switzerland, you may contact the
                    <a href="https://www.edoeb.admin.ch/edoeb/en/home.html">
                        <u>Federal Data Protection and Information Commissioner</u>
                    </a>
                    .
                </p>
                <p>
                    <strong><u>Withdrawing your consent:</u></strong> If we are relying on your
                    consent to process your personal information, which may be express and/or
                    implied consent depending on the applicable law, you have the right to
                    withdraw your consent at any time. You can withdraw your consent at any time
                    by contacting us by using the contact details provided in the section "HOW
                    CAN YOU CONTACT US ABOUT THIS NOTICE?" below or updating your preferences.
                </p>
                <p>
                    However, please note that this will not affect the lawfulness of the
                    processing before its withdrawal nor, when applicable law allows, will it
                    affect the processing of your personal information conducted in reliance on
                    lawful processing grounds other than consent.
                </p>
                <p>
                    <strong>Account Information</strong>
                </p>
                <p>
                    If you would at any time like to review or change the information in your
                    account or terminate your account, you can:
                </p>
                <ul>
                    <li>
                        Log in to your account settings and update your user account.
                    </li>
                    <li>
                        Contact us using the contact information provided.
                    </li>
                </ul>
                <p>
                    Upon your request to terminate your account, we will deactivate or delete
                    your account and information from our active databases. However, we may
                    retain some information in our files to prevent fraud, troubleshoot
                    problems, assist with any investigations, enforce our legal terms and/or
                    comply with applicable legal requirements.
                </p>
                <p>
                    <strong><u>Cookies and similar technologies:</u></strong> Most Web browsers
                    are set to accept cookies by default. If you prefer, you can usually choose
                    to set your browser to remove cookies and to reject cookies. If you choose
                    to remove cookies or reject cookies, this could affect certain features or
                    services of our Services. You may also
                    <a href="http://www.aboutads.info/choices/">
                        <u>opt out of interest-based advertising by advertisers</u>
                    </a>
                    on our Services.
                </p>
                <p>
                    If you have questions or comments about your privacy rights, you may email
                    us at &nbsp;
                     <a className="text-blue-500" href="mailto:support@quranpoint.com" >support@quranpoint.com.</a>
                </p>
                <p>
                    <strong>11. CONTROLS FOR DO-NOT-TRACK FEATURES</strong>
                </p>
                <p>
                    Most web browsers and some mobile operating systems and mobile applications
                    include a Do-Not-Track ("DNT") feature or setting you can activate to signal
                    your privacy preference not to have data about your online browsing
                    activities monitored and collected. At this stage, no uniform technology
                    standard for recognizing and implementing DNT signals has been finalized. As
                    such, we do not currently respond to DNT browser signals or any other
                    mechanism that automatically communicates your choice not to be tracked
                    online. If a standard for online tracking is adopted that we must follow in
                    the future, we will inform you about that practice in a revised version of
                    this Privacy Notice.
                </p>
                <p>
                    California law requires us to let you know how we respond to web browser DNT
                    signals. Because there currently is not an industry or legal standard for
                    recognizing or honoring DNT signals, we do not respond to them at this time.
                </p>
                <p>
                    <strong>
                        12. DO UNITED STATES RESIDENTS HAVE SPECIFIC PRIVACY RIGHTS?
                    </strong>
                </p>
                <p>
                    <strong><em>In Short:</em></strong>
                    <em>
                        If you are a resident of California, Colorado, Connecticut, Delaware,
                        Florida, Indiana, Iowa, Kentucky, Minnesota, Montana, Nebraska, New
                        Hampshire, New Jersey, Oregon, Tennessee, Texas, Utah, or Virginia, you
                        may have the right to request access to and receive details about the
                        personal information we maintain about you and how we have processed it,
                        correct inaccuracies, get a copy of, or delete your personal
                        information. You may also have the right to withdraw your consent to our
                        processing of your personal information. These rights may be limited in
                        some circumstances by applicable law. More information is provided
                        below.
                    </em>
                </p>
                <p>
                    <strong>Categories of Personal Information We Collect</strong>
                </p>
                <p>
                    We have collected the following categories of personal information in the
                    past twelve (12) months:
                </p>
                <table border="2" cellspacing="3">
                    <tbody>
                        <tr>
                            <td>
                                <p>
                                    <strong>Category</strong>
                                </p>
                            </td>
                            <td>
                                <p>
                                    <strong>Examples</strong>
                                </p>
                            </td>
                            <td>
                                <p>
                                    <strong>Collected</strong>
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>
                                    A. Identifiers
                                </p>
                            </td>
                            <td>
                                <p>
                                    Contact details, such as real name, alias, postal address,
                                    telephone or mobile contact number, unique personal
                                    identifier, online identifier, Internet Protocol address,
                                    email address, and account name
                                </p>
                            </td>
                            <td>
                                <p>
                                    NO
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>
                                    B. Personal information as defined in the California
                                    Customer Records statute
                                </p>
                            </td>
                            <td>
                                <p>
                                    Name, contact information, education, employment, employment
                                    history, and financial information
                                </p>
                            </td>
                            <td>
                                <p>
                                    NO
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>
                                    C. Protected classification characteristics under state or
                                    federal law
                                </p>
                            </td>
                            <td>
                                <p>
                                    Gender, age, date of birth, race and ethnicity, national
                                    origin, marital status, and other demographic data
                                </p>
                            </td>
                            <td>
                                <p>
                                    NO
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>
                                    D. Commercial information
                                </p>
                            </td>
                            <td>
                                <p>
                                    Transaction information, purchase history, financial
                                    details, and payment information
                                </p>
                            </td>
                            <td>
                                <p>
                                    NO
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>
                                    E. Biometric information
                                </p>
                            </td>
                            <td>
                                <p>
                                    Fingerprints and voiceprints
                                </p>
                            </td>
                            <td>
                                <p>
                                    NO
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>
                                    F. Internet or other similar network activity
                                </p>
                            </td>
                            <td>
                                <p>
                                    Browsing history, search history, online behavior, interest
                                    data, and interactions with our and other websites,
                                    applications, systems, and advertisements
                                </p>
                            </td>
                            <td>
                                <p>
                                    NO
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>
                                    G. Geolocation data
                                </p>
                            </td>
                            <td>
                                <p>
                                    Device location
                                </p>
                            </td>
                            <td>
                                <p>
                                    NO
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>
                                    H. Audio, electronic, sensory, or similar information
                                </p>
                            </td>
                            <td>
                                <p>
                                    Images and audio, video or call recordings created in
                                    connection with our business activities
                                </p>
                            </td>
                            <td>
                                <p>
                                    NO
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>
                                    I. Professional or employment-related information
                                </p>
                            </td>
                            <td>
                                <p>
                                    Business contact details in order to provide you our
                                    Services at a business level or job title, work history, and
                                    professional qualifications if you apply for a job with us
                                </p>
                            </td>
                            <td>
                                <p>
                                    NO
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>
                                    J. Education Information
                                </p>
                            </td>
                            <td>
                                <p>
                                    Student records and directory information
                                </p>
                            </td>
                            <td>
                                <p>
                                    NO
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>
                                    K. Inferences drawn from collected personal information
                                </p>
                            </td>
                            <td>
                                <p>
                                    Inferences drawn from any of the collected personal
                                    information listed above to create a profile or summary
                                    about, for example, an individual's preferences and
                                    characteristics
                                </p>
                            </td>
                            <td>
                                <p>
                                    NO
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>
                                    L. Sensitive personal Information
                                </p>
                            </td>
                            <td>
                            </td>
                            <td>
                                <p>
                                    NO
                                </p>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <p>
                    We may also collect other personal information outside of these categories
                    through instances where you interact with us in person, online, or by phone
                    or mail in the context of:
                </p>
                <ul>
                    <li>
                        Receiving help through our customer support channels;
                    </li>
                    <li>
                        Participation in customer surveys or contests; and
                    </li>
                    <li>
                        Facilitation in the delivery of our Services and to respond to your
                        inquiries.
                    </li>
                </ul>
                <p>
                    We will use and retain the collected personal information as needed to
                    provide the Services or for:
                </p>
                <ul>
                    <li>
                        Category H - As long as the user has an account with us
                    </li>
                </ul>
                <p>
                    <strong>Sources of Personal Information</strong>
                </p>
                <p>
                    Learn more about the sources of personal information we collect in "WHAT
                    INFORMATION DO WE COLLECT?"
                </p>
                <p>
                    <strong>How We Use and Share Personal Information</strong>
                </p>
                <p>
                    Learn more about how we use your personal information in the section, "HOW
                    DO WE PROCESS YOUR INFORMATION?"
                </p>
                <p>
                    <strong>Will your information be shared with anyone else?</strong>
                </p>
                <p>
                    We may disclose your personal information with our service providers
                    pursuant to a written contract between us and each service provider. Learn
                    more about how we disclose personal information to in the section, "WHEN AND
                    WITH WHOM DO WE SHARE YOUR PERSONAL INFORMATION?"
                </p>
                <p>
                    We may use your personal information for our own business purposes, such as
                    for undertaking internal research for technological development and
                    demonstration. This is not considered to be "selling" of your personal
                    information.
                </p>
                <p>
                    We have not disclosed, sold, or shared any personal information to third
                    parties for a business or commercial purpose in the preceding twelve (12)
                    months. We will not sell or share personal information in the future
                    belonging to website visitors, users, and other consumers.
                </p>
                <p>
                    <strong>Your Rights</strong>
                </p>
                <p>
                    You have rights under certain US state data protection laws. However, these
                    rights are not absolute, and in certain cases, we may decline your request
                    as permitted by law. These rights include:
                </p>
                <ul>
                    <li>
                        <strong>Right to know</strong> whether or not we are processing your
                        personal data
                    </li>
                    <li>
                        <strong>Right to access</strong>your personal data
                    </li>
                    <li>
                        <strong>Right to correct</strong>inaccuracies in your personal data
                    </li>
                    <li>
                        <strong>Right to request</strong> the deletion of your personal data
                    </li>
                    <li>
                        <strong>Right to obtain a copy</strong>of the personal data you
                        previously shared with us
                    </li>
                    <li>
                        <strong>Right to non-discrimination</strong> for exercising your
                        rights
                    </li>
                    <li>
                        <strong>Right to opt out</strong> of the processing of your personal
                        data if it is used for targeted advertising (or sharing as defined under
                        California's privacy law), the sale of personal data, or profiling in
                        furtherance of decisions that produce legal or similarly significant
                        effects ("profiling")
                    </li>
                </ul>
                <p>
                    Depending upon the state where you live, you may also have the following
                    rights:
                </p>
                <ul>
                    <li>
                        Right to access the categories of personal data being processed (as
                        permitted by applicable law, including Minnesota's privacy law)
                    </li>
                    <li>
                        Right to obtain a list of the categories of third parties to which we
                        have disclosed personal data (as permitted by applicable law, including
                        California's and Delaware's privacy law)
                    </li>
                    <li>
                        Right to obtain a list of specific third parties to which we have
                        disclosed personal data (as permitted by applicable law, including
                        Minnesota's and Oregon's privacy law)
                    </li>
                    <li>
                        Right to review, understand, question, and correct how personal data
                        has been profiled (as permitted by applicable law, including Minnesota's
                        privacy law)
                    </li>
                    <li>
                        Right to limit use and disclosure of sensitive personal data (as
                        permitted by applicable law, including California's privacy law)
                    </li>
                    <li>
                        Right to opt out of the collection of sensitive data and personal data
                        collected through the operation of a voice or facial recognition feature
                        (as permitted by applicable law, including Florida's privacy law)
                    </li>
                </ul>
                <p>
                    <strong>How to Exercise Your Rights</strong>
                </p>
                <p>
                    To exercise these rights, you can contact us by submitting a data subject
                    access request, by emailing us at  &nbsp;
                     <a className="text-blue-500" href="mailto:support@quranpoint.com" >support@quranpoint.com.</a>, or by referring to
                    the contact details at the bottom of this document.
                </p>
                <p>
                    Under certain US state data protection laws, you can designate an authorized
                    agent to make a request on your behalf. We may deny a request from an
                    authorized agent that does not submit proof that they have been validly
                    authorized to act on your behalf in accordance with applicable laws. <br />
                </p>
                <p>
                    <strong>Request Verification</strong>
                </p>
                <p>
                    Upon receiving your request, we will need to verify your identity to
                    determine you are the same person about whom we have the information in our
                    system. We will only use personal information provided in your request to
                    verify your identity or authority to make the request. However, if we cannot
                    verify your identity from the information already maintained by us, we may
                    request that you provide additional information for the purposes of
                    verifying your identity and for security or fraud-prevention purposes.
                </p>
                <p>
                    If you submit the request through an authorized agent, we may need to
                    collect additional information to verify your identity before processing
                    your request and the agent will need to provide a written and signed
                    permission from you to submit such request on your behalf.
                </p>
                <p>
                    <strong>Appeals</strong>
                </p>
                <p>
                    Under certain US state data protection laws, if we decline to take action
                    regarding your request, you may appeal our decision by emailing us at
                     &nbsp;
                     <a className="text-blue-500" href="mailto:support@quranpoint.com" >support@quranpoint.com.</a> We will inform you in writing of any action taken or
                    not taken in response to the appeal, including a written explanation of the
                    reasons for the decisions. If your appeal is denied, you may submit a
                    complaint to your state attorney general.
                </p>
                <p>
                    <strong></strong>
                </p>
                <p>
                    <strong>California "Shine The Light" Law</strong>
                </p>
                <p>
                    California Civil Code Section 1798.83, also known as the "Shine The Light"
                    law, permits our users who are California residents to request and obtain
                    from us, once a year and free of charge, information about categories of
                    personal information (if any) we disclosed to third parties for direct
                    marketing purposes and the names and addresses of all third parties with
                    which we shared personal information in the immediately preceding calendar
                    year. If you are a California resident and would like to make such a
                    request, please submit your request in writing to us by using the contact
                    details provided in the section "HOW CAN YOU CONTACT US ABOUT THIS NOTICE?"
                </p>
                <p>
                    <br />
                    <strong>13. DO OTHER REGIONS HAVE SPECIFIC PRIVACY RIGHTS?</strong>
                </p>
                <p>
                    <strong><em>In Short:</em></strong>
                    <em>
                        You may have additional rights based on the country you reside in.
                    </em>
                </p>
                <p>
                    <strong>Australia and New Zealand</strong>
                </p>
                <p>
                    We collect and process your personal information under the obligations and
                    conditions set by Australia's Privacy Act 1988 and New Zealand's Privacy Act
                    2020 (Privacy Act).
                </p>
                <p>
                    This Privacy Notice satisfies the notice requirements defined in both
                    Privacy Acts, in particular: what personal information we collect from you,
                    from which sources, for which purposes, and other recipients of your
                    personal information.
                </p>
                <p>
                    If you do not wish to provide the personal information necessary to fulfill
                    their applicable purpose, it may affect our ability to provide our services,
                    in particular:
                </p>
                <ul>
                    <li>
                        offer you the products or services that you want
                    </li>
                    <li>
                        respond to or help with your requests
                    </li>
                    <li>
                        manage your account with us
                    </li>
                    <li>
                        confirm your identity and protect your account
                    </li>
                </ul>
                <p>
                    At any time, you have the right to request access to or correction of your
                    personal information. You can make such a request by contacting us by using
                    the contact details provided in the section "HOW CAN YOU REVIEW, UPDATE, OR
                    DELETE THE DATA WE COLLECT FROM YOU?"
                </p>
                <p>
                    If you believe we are unlawfully processing your personal information, you
                    have the right to submit a complaint about a breach of the Australian
                    Privacy Principles to the
                    <a
                        href="https://www.oaic.gov.au/privacy/privacy-complaints/lodge-a-privacy-complaint-with-us"
                    >
                        <u>Office of the Australian Information Commissioner</u>
                    </a>
                    and a breach of New Zealand's Privacy Principles to the
                    <a href="https://www.privacy.org.nz/your-rights/making-a-complaint/">
                        <u>Office of New Zealand Privacy Commissioner</u>
                    </a>
                    .
                </p>
                <p>
                    <strong>Republic of South Africa</strong>
                </p>
                <p>
                    At any time, you have the right to request access to or correction of your
                    personal information. You can make such a request by contacting us by using
                    the contact details provided in the section "HOW CAN YOU REVIEW, UPDATE, OR
                    DELETE THE DATA WE COLLECT FROM YOU?"
                </p>
                <p>
                    If you are unsatisfied with the manner in which we address any complaint
                    with regard to our processing of personal information, you can contact the
                    office of the regulator, the details of which are:
                </p>
                <p>
                    <a href="https://inforegulator.org.za/">
                        <u>The Information Regulator (South Africa)</u>
                    </a>
                </p>
                <p>
                    General enquiries:
                    <a href="mailto:enquiries@inforegulator.org.za">
                        <u>enquiries@inforegulator.org.za</u>
                    </a>
                </p>
                <p>
                    Complaints (complete POPIA/PAIA form 5):
                    <a href="mailto:PAIAComplaints@inforegulator.org.za">
                        <u>PAIAComplaints@inforegulator.org.za</u>
                    </a>
                    &amp;
                    <a href="mailto:POPIAComplaints@inforegulator.org.za">
                        <u>POPIAComplaints@inforegulator.org.za</u>
                    </a>
                </p>
                <p>
                    <strong>14. DO WE MAKE UPDATES TO THIS NOTICE?</strong>
                </p>
                <p>
                    <strong><em>In Short:</em></strong>
                    <em>
                        Yes, we will update this notice as necessary to stay compliant with
                        relevant laws.
                    </em>
                </p>
                <p>
                    We may update this Privacy Notice from time to time. The updated version
                    will be indicated by an updated "Revised" date at the top of this Privacy
                    Notice. If we make material changes to this Privacy Notice, we may notify
                    you either by prominently posting a notice of such changes or by directly
                    sending you a notification. We encourage you to review this Privacy Notice
                    frequently to be informed of how we are protecting your information.
                </p>
                <p>
                    <strong>15. HOW CAN YOU CONTACT US ABOUT THIS NOTICE?</strong>
                </p>
                <p>
                    If you have questions or comments about this notice, you may email us at  &nbsp;
                     <a className="text-blue-500" href="mailto:support@quranpoint.com" >support@quranpoint.com.</a>  or contact us by post at:
                </p>
                <p>
                    Skyraan Technologies OPC Private Limited
                </p>
                <p>
                    Opp.to: Fire service station, Peelamedu,
                </p>
                <p>
                    Coimbatore, Tamil Nadu - 641004,
                </p>
                <p>
                    India.
                </p>
                <p>
                    <strong>
                        16. HOW CAN YOU REVIEW, UPDATE, OR DELETE THE DATA WE COLLECT FROM YOU?
                    </strong>
                </p>
                <p>
                    Based on the applicable laws of your country or state of residence in the
                    US, you may have the right to request access to the personal information we
                    collect from you, details about how we have processed it, correct
                    inaccuracies, or delete your personal information. You may also have the
                    right to withdraw your consent to our processing of your personal
                    information. These rights may be limited in some circumstances by applicable
                    law. To request to review, delete your personal information, please choose
                    the "Delete your account" in the app settings.
                </p>
            </div>

        </div>
    )
}

export default Pricacypolicy;
